export { WellKnownURLs } from './WellKnownURLs';
